import { MakeAPaymentApiClient } from "raci-make-a-payment-clientproxy";
import { useSessionIdStorageKey, useSsoApiClient } from "raci-react-library";
import { BypassService } from "raci-react-library-npe";
import { useNpeBffApiClient } from "../../../__NPE__/useApiClient";
import { ADB2C_CLIENT_ID, BFF_API_BASE_URL } from "../../constants";

const useRealBffApiClient = () => {
  const sessionIdStorageKey = useSessionIdStorageKey();
  return useSsoApiClient({
    Client: MakeAPaymentApiClient,
    clientId: ADB2C_CLIENT_ID,
    apiBaseUrl: BFF_API_BASE_URL,
    sessionIdStorageKey,
  });
};

export let useApiClient = useRealBffApiClient;

/*
 ** Keep environment checks as compile-time constants.
 ** The PRD build tree-shakes unused NPE modules.
 */
if (
  import.meta.env.VITE_ENVIRONMENT === "LOCAL" ||
  import.meta.env.VITE_ENVIRONMENT === "DEV" ||
  import.meta.env.VITE_ENVIRONMENT === "SIT" ||
  import.meta.env.VITE_ENVIRONMENT === "UAT"
) {
  useApiClient = useNpeBffApiClient;

  if (import.meta.env.VITE_ENVIRONMENT === "UAT" && !BypassService.isUsingTestLaunchPage()) {
    useApiClient = useRealBffApiClient;
  }
}

export default useApiClient;
